import type { InstitutionTheme } from '../types';
import { montgomeryCollegeColors } from './colors';

// Montgomery College (Maryland) institutional theme — W52 Worker M, S3 (2026-10-12).
// NOT the University of Maryland (`../umd`): the two share most subject prefixes, so the
// example codes below keep Montgomery's mandatory space ("MATH 181", never "MATH181").
//
// Names: "Montgomery College" from the 2026-27 catalog (catalog.montgomerycollege.edu). The
// college calls itself "MC", but Merced College uses the same abbreviation on this platform,
// so the short name stays the full name. registrationPortalName VERIFIED first-party: the
// catalog header on every captured page reads "Log In to MyMC", and the Academic Regulations
// page says "available for student use through the MyMC portal".
//
// Example course codes vetted against the S0 index (966 codes,
// admin_tools/backend/data/onboarding/montgomery-college/probes/course_index_s0.json):
// MATH 181 (Calculus I — a GE MATF course), ENGL 102 (the ENGF foundation course),
// CMSC 140. First entry is the primary example.
export const montgomeryCollegeTheme: InstitutionTheme = {
  slug: 'montgomery-college',
  universityName: 'Montgomery College',
  universityShortName: 'Montgomery College',
  registrationPortalName: 'MyMC',
  exampleCourseCodes: ['MATH 181', 'ENGL 102', 'CMSC 140'],
  colors: montgomeryCollegeColors,
};
